import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {getExtensionSettingsKey} from '@api/model/ui'
import {UIComponent} from '@api/ui-component'
import {LinkButton} from '@components/common/base/buttons'
import * as extensionsStore from '../../extensions-store'

const TwMain = tw.div`
  flex-1
  px-24
  pb-24
  pt-8
`

const TwBack = tw.div`
  mb-10
`

const TwHeader = tw.h5`
  h1-regular
  text-primary
  mb-24
`

type ExtensionSettingsMainProps = {
  openedDetails?: extensionsStore.ExtensionStore
  openedSettings: extensionsStore.ExtensionStore
  onClickBack: () => void
}

export const ExtensionSettingsMain = observer(
  ({
    openedDetails,
    openedSettings,
    onClickBack
  }: ExtensionSettingsMainProps) => {
    const getSettingsKey = getExtensionSettingsKey(openedSettings.id)

    return (
      <TwMain>
        <TwBack>
          <LinkButton icon="IconArrowLeft" onClick={onClickBack}>
            {openedDetails
              ? Lang.msg.extensions.gallery.goBackToComments
              : Lang.msg.extensions.gallery.goBackToGallery}
          </LinkButton>
        </TwBack>
        <TwHeader>
          {Lang.msg.extensions.extensionSettings} «{openedSettings.name}»
        </TwHeader>
        <main>{openedSettings && <UIComponent id={getSettingsKey} />}</main>
      </TwMain>
    )
  }
)
